import React from 'react';
import SeoWrapper from '../components/SeoWrapper';
import Contact from '../components/Contact';
import content from '../data/content.json';

const ContactPage = ({ language }) => {
  return (
    <>
      <SeoWrapper
        title={language === 'pl' ? "Kontakt" : "Contact"}
        description={language === 'pl' ? "Skontaktuj się ze mną - wsparcie IT i usługi programistyczne" : "Contact me - IT support and software services"}
        url="/kontakt"
      />
      <div className="pt-20 min-h-screen flex flex-col justify-center">
        <Contact contact={content.contact} language={language} />
      </div>
    </>
  );
};

export default ContactPage;
